module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_03_6NX26_1SF_GLR.30212c3e.png";